export default __webpack_public_path__ + "e72e1b208fa5a657f8af58749da871ca.hex";